import lenis from "./lenis";

/**
 * Full-screen mobile menu drawer (hamburger). Figma: 4667:30841 / 4667:30991.
 * Root list + drill-down panels with Back; closes on backdrop, Escape, outside tap.
 */
export function initNavigationDrawer() {
  const drawer = document.getElementById("site-nav-drawer");
  const btn = document.querySelector(".site-header__icon-btn--menu");
  if (!drawer || !btn) {
    return;
  }

  const scroller = drawer.querySelector(".nav-drawer__scroller");
  const views = drawer.querySelectorAll("[data-nav-drawer-view]");
  const openTriggers = drawer.querySelectorAll("[data-nav-drawer-open]");
  const backBtns = drawer.querySelectorAll("[data-nav-drawer-back]");
  const closeTargets = drawer.querySelectorAll("[data-nav-drawer-close]");

  function showView(viewId) {
    views.forEach((v) => {
      const id = v.getAttribute("data-nav-drawer-view");
      const show = viewId === "root" ? id === "root" : id === viewId;
      v.hidden = !show;
      v.classList.toggle("is-active", show);
      v.setAttribute("aria-hidden", show ? "false" : "true");
    });

    openTriggers.forEach((t) => {
      const panel = t.getAttribute("data-nav-drawer-open");
      t.setAttribute("aria-expanded", String(viewId !== "root" && panel === viewId));
    });

    if (scroller) {
      scroller.scrollTop = 0;
    }
  }

  function lockScroll() {
    document.documentElement.style.overflow = "hidden";
    lenis().stop()
  }

  function unlockScroll() {
    document.documentElement.style.overflow = "";
    lenis().start()
  }

  function openDrawer() {
    drawer.classList.add("is-open");
    drawer.removeAttribute("hidden");
    drawer.setAttribute("aria-hidden", "false");
    lockScroll();
    showView("root");
    btn.classList.add("is-open");
    document.body.classList.add("nav-drawer-open");
    btn.setAttribute("aria-expanded", "true");
    btn.setAttribute("aria-label", "Close menu");
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("hidden", "");
    drawer.setAttribute("aria-hidden", "true");
    unlockScroll();
    showView("root");
    btn.classList.remove("is-open");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", "Open menu");
    document.body.classList.remove("nav-drawer-open");
  }

  function toggleDrawer() {
    if (drawer.classList.contains("is-open")) {
      closeDrawer();
    } else {
      openDrawer();
    }
  }

  btn.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleDrawer();
  });

  closeTargets.forEach((el) => {
    el.addEventListener("click", closeDrawer);
  });

  openTriggers.forEach((t) => {
    t.addEventListener("click", () => {
      const id = t.getAttribute("data-nav-drawer-open");
      if (id) {
        showView(id);
      }
    });
  });

  backBtns.forEach((b) => {
    b.addEventListener("click", () => {
      showView("root");
    });
  });

  drawer.querySelectorAll('a.nav-drawer__row--link[href]').forEach((a) => {
    a.addEventListener("click", () => {
      const href = a.getAttribute("href");
      if (href && href !== "#") {
        closeDrawer();
      }
    });
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  document.addEventListener("click", (e) => {
    if (!drawer.classList.contains("is-open")) {
      return;
    }
    if (drawer.contains(e.target) || btn.contains(e.target)) {
      return;
    }
    closeDrawer();
  });

  showView("root");
}
